import React, { Component } from "react";
import { Avatar, Upload, message } from "antd";
import { UploadOutlined, UserOutlined, DeleteOutlined } from "@ant-design/icons";
import ButtonItem from "./ButtonItem";

const TIPOS_PERMITIDOS = ["image/jpeg", "image/png", "image/webp"];
const MAX_MB = 5;

const leerBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

class FotoRostroEmpleado extends Component {
  async onSubirFoto(e) {
    const archivo = e.file;
    if (!TIPOS_PERMITIDOS.includes(archivo.type)) {
      message.error("La fotografía debe ser JPG, PNG o WEBP");
      return;
    }
    if (archivo.size > MAX_MB * 1024 * 1024) {
      message.error(`La fotografía no debe pesar más de ${MAX_MB} MB`);
      return;
    }
    try {
      const base64 = await leerBase64(archivo);
      this.props.onChange?.({ url: base64, base64 });
    } catch (error) {
      message.error("No se pudo leer la fotografía");
    }
  }

  quitarFoto() {
    this.props.onChange?.(null);
  }

  render() {
    const { value, disabled } = this.props;
    const preview = value?.base64 || (value?.url?.startsWith("data:") ? value.url : null);

    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
        <Avatar
          size={100}
          src={preview || undefined}
          icon={<UserOutlined />}
          style={{ background: "#bfbfbf", fontSize: 48 }}
        />
        {!disabled && (
          <Upload accept="image/*" showUploadList={false} customRequest={this.onSubirFoto.bind(this)}>
            <ButtonItem blanco size="small" icon={<UploadOutlined />}>
              {preview ? "Cambiar" : "Subir foto"}
            </ButtonItem>
          </Upload>
        )}
        {!disabled && preview && (
          <ButtonItem rojo size="small" icon={<DeleteOutlined />} onClick={this.quitarFoto.bind(this)}>
            Quitar
          </ButtonItem>
        )}
        <span style={{ fontSize: 11, color: "#aaa" }}>Fotografía</span>
      </div>
    );
  }
}

export default FotoRostroEmpleado;
